/**
 * Generic CSV download helper. RFC 4180 quoting. Ported verbatim from the
 * dane etf-website `lib/csv-download.ts`.
 */

export interface CsvColumn<Row> {
  header: string;
  value: (row: Row) => string | number | null | undefined;
}

function quoteCell(v: string | number | null | undefined): string {
  if (v == null) return '""';
  const s = typeof v === "number" ? String(v) : v;
  return `"${s.replace(/"/g, '""')}"`;
}

export function rowsToCsv<Row>(rows: Row[], columns: CsvColumn<Row>[]): string {
  const header = columns.map((c) => quoteCell(c.header)).join(",");
  const body = rows.map((r) => columns.map((c) => quoteCell(c.value(r))).join(",")).join("\r\n");
  return `\uFEFF${header}\r\n${body}\r\n`;
}

export function downloadCsv(filename: string, csv: string): void {
  if (typeof document === "undefined") return;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
